// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   AGCX Listing Project Page Styles
   File: listing-project.css
   ========================================================================== */

/* --- Main Page Container & Layout --- */
.listing-project-page {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background-color: #FFFFFF;
    color: #111827;
    padding: 60px 0 100px 0;
    position: relative;
    overflow: hidden;
}

/* Background Ambient Blur Blobs (Section-wise Left & Right) */
.bg-blur-glow {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
    filter: blur(80px);
    opacity: 0.85;
}

.glow-top-left {
    top: -140px;
    opacity: 0.3;
    left: -200px;
    width: 450px;
    height: 450px;
    background: radial-gradient(circle, rgb(209 170 103 / 90%) 0%, rgba(246, 224, 172, 0) 70%);
}

body.light_theme .glow-middle-left {
    opacity: 1;
}

.glow-middle-right {
    opacity: 0.3;
    top: 260px;
    right: -120px;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(191, 223, 255, 0.75) 0%, rgba(191, 223, 255, 0) 70%);
}

body.light_theme .glow-middle-right {
    opacity: 1;
}

.glow-middle-left {
    top: 750px;
    left: -140px;
    opacity: 0.2;
    width: 520px;
    height: 520px;
    background: radial-gradient(circle, rgba(191, 223, 255, 0.7) 0%, rgba(191, 223, 255, 0) 70%);
}

.glow-bottom-right {
    bottom: -80px;
    right: -120px;
    width: 580px;
    opacity: 0.2;
    height: 580px;
    background: radial-gradient(circle, rgba(246, 224, 172, 0.75) 0%, rgba(246, 224, 172, 0) 70%);
}

body.light_theme .glow-bottom-right {
    opacity: 1;
}

.listing-project-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

/* Common Gold Accent Text */
.listing-hero .gold-text {
    color: #D3B06C;
    font-weight: 700;
    display: block;
}

/* Common Primary CTA Button */
.listing-apply-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 28px;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 500;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    text-decoration: none;
}

.listing-apply-btn:hover {
    background-color: #C09D5B;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);
}

.listing-apply-btn i {
    font-size: 16px;
    transition: transform 0.2s ease;
}

.listing-apply-btn:hover i {
    transform: translateX(3px);
}


/* ==========================================================================
   --- Hero Section ---
   ========================================================================== */
.listing-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 60px;
    margin-bottom: 90px;
    padding-top: 20px;
}

.listing-hero-content {
    flex: 1 1;
    max-width: 580px;
}

.listing-hero-subtitle {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #9CA3AF;
    margin-bottom: 12px;
    letter-spacing: 0.2px;
}

.listing-hero-title {
    font-size: 52px;
    font-weight: 700;
    color: #111827;
    line-height: 1.25;
    margin: 0 0 20px 0;
}

.listing-hero-desc {
    font-size: 16px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 32px 0;
}

.listing-hero-image {
    width: 400px;
    max-width: 100%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0px;
    right: 60px;
}

.listing-hero-image img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
    filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.05));
    animation: floatAnimation 4s ease-in-out infinite alternate;
}

@keyframes floatAnimation {
    0% {
        transform: translateY(0px);
    }

    100% {
        transform: translateY(-10px);
    }
}


/* ==========================================================================
   --- AGCX Listing Process Section ---
   ========================================================================== */
.listing-process-section {
    margin-bottom: 90px;
}

.section-header {
    text-align: center;
    margin-bottom: 44px;
}

.section-subtitle {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #9CA3AF;
    margin-bottom: 6px;
}

.section-title {
    font-size: 32px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    letter-spacing: -0.3px;
}

.process-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}

.process-card {
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 18px;
    padding: 30px 20px 28px 20px;
    text-align: center;
    box-shadow: 0 0px 4px rgb(0 0 0 / 8%);
    transition: all 0.25s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.process-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.06);
    border-color: #E2E8F0;
}

.step-badge {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #F8FAFC;
    border: 1px solid #E2E8F0;
    color: #D1AA67;
    font-size: 13px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.process-icon {
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.process-icon img {
    max-height: 100%;
    width: auto;
    object-fit: contain;
}

.process-card h3 {
    font-size: 17px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 10px 0;
    line-height: 1.3;
}

body.light_theme .process-card h3 {
    color: #111827;
}

.process-card p {
    font-size: 13px;
    color: #64748B;
    line-height: 1.55;
    margin: 0;
}


/* ==========================================================================
   --- Why List With Us / Features Section ---
   ========================================================================== */
.listing-features-section {
    margin-bottom: 100px;
}

.features-grid {
    display: grid;
    gap: 24px;
}

.features-grid.grid-4 {
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 24px;
}

.features-grid.grid-3 {
    grid-template-columns: repeat(3, 1fr);
}

.feature-card {
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 18px;
    padding: 28px 24px;
    box-shadow: 0 0px 4px rgb(0 0 0 / 8%);
    transition: all 0.25s ease;
    display: flex;
    flex-direction: column;
}

.feature-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.06);
    border-color: #E2E8F0;
}

.feature-icon {
    height: 65px;
    display: flex;
    align-items: center;
    margin-bottom: 18px;
}

.feature-icon img {
    max-height: 100%;
    width: auto;
    object-fit: contain;
}

.feature-card h3 {
    font-size: 17px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 8px 0;
    line-height: 1.3;
}

body.light_theme .feature-card h3 {
    color: #111827;
}

.feature-card p {
    font-size: 13.5px;
    color: #64748B;
    line-height: 1.55;
    margin: 0;
}


/* ==========================================================================
   --- Call to Action Banner Section ---
   ========================================================================== */
.listing-cta-banner {
    background: #f7f7f70f;
    border: none;
    border-radius: 24px;
    padding: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    /* overflow: hidden; */
    margin-bottom: 60px;
}

body.light_theme .listing-cta-banner {
    background: #F7F7F7;
}

.cta-banner-content {
    max-width: 520px;
    z-index: 2;
}

.cta-subtitle {
    display: block;
    font-size: 16px;
    font-weight: 600;
    color: #D3B06C;
    margin-bottom: 8px;
}

.cta-titlehome {
    font-size: 34px;
    font-weight: 800;
    color: #111827;
    margin: 0 0 14px 0;
    line-height: 1.2;
    letter-spacing: -0.4px;
}

.cta-desc {
    font-size: 15px;
    color: #475569;
    line-height: 1.6;
    margin: 0 0 28px 0;
}

.cta-banner-image {
    width: 450px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.cta-banner-image img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}


/* ==========================================================================
   --- Listing Application Form (Modal Section) ---
   ========================================================================== */

.listing-form-header {
    text-align: center;
    margin-bottom: 30px;
}

.listing-form-header h3 {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 8px 0;
}

body.light_theme .listing-form-header h3 {
    color: #111827;
}

.listing-form-header p {
    font-size: 14px;
    color: #64748B;
    margin: 0;
}

.listing-form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.form-group-full {
    grid-column: span 2;
}

.form-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-field label {
    font-size: 13.5px;
    font-weight: 600;
    color: #334155;
}

.form-field label .required {
    color: #EF4444;
    margin-left: 3px;
}

.form-input {
    width: 100%;
    padding: 12px 16px;
    border-radius: 10px;
    border: 1px solid #CBD5E1;
    background-color: #F8FAFC;
    font-size: 14px;
    color: #0F172A;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    outline: none;
}

.form-input:focus {
    border-color: #D3B06C;
    background-color: #FFFFFF;
    box-shadow: 0 0 0 3px rgba(211, 176, 108, 0.15);
}

.form-phone-group {
    display: flex;
    gap: 10px;
}

.form-phone-code {
    width: 100px;
    flex-shrink: 0;
}

.form-submit-btn {
    grid-column: span 2;
    margin-top: 10px;
    padding: 14px;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;
}

.form-submit-btn:hover {
    background-color: #C09D5B;
}

/* Modal Overlay */
.listing-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999999;
    padding: 20px;
    animation: fadeIn 0.2s ease;
}

body.light_theme .listing-modal-overlay {
    background-color: rgba(255, 255, 255, 0.20);
}

.listing-modal-content {
    background-color: rgb(255 255 255 / 20%);
    border-radius: 24px;
    width: 100%;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    max-width: 680px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 36px;
    position: relative;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.modal-close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    background: #F1F5F9;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #64748B;
    font-size: 20px;
    transition: all 0.2s ease;
}

.modal-close-btn:hover {
    background-color: #E2E8F0;
    color: #0F172A;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}


/* ==========================================================================
   --- Responsive Adjustments ---
   ========================================================================== */

@media (max-width: 1500px) {

    .listing-project-container {
        max-width: 95%;
    }

    .listing-hero-title {
        font-size: 48px;
    }

}

@media (max-width: 1200px) {

    .cta-banner-image {
        width: 320px;
    }

    .cta-titlehome {
        font-size: 28px;
    }

    .listing-hero-title {
        font-size: 38px;
    }

    .section-title {
        font-size: 36px;
    }

}

@media (max-width: 1024px) {


    .listing-hero-title {
        font-size: 38px;
    }

    .process-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .features-grid.grid-4,
    .features-grid.grid-3 {
        grid-template-columns: repeat(2, 1fr);
    }

    .listing-cta-banner {
        padding: 40px;
    }
}

@media (max-width: 991px) {


    .listing-hero {
        gap: 30px;
        margin-bottom: 60px;
    }

    .listing-hero-image {
        width: 280px;
        right: 10px;
    }

    .process-grid {
        grid-template-columns: 1fr 1fr;
    }

    .features-grid.grid-4,
    .features-grid.grid-3 {
        grid-template-columns: 1fr 1fr;
    }

    .cta-banner-content {
        max-width: 60%;
    }

    .listing-cta-banner {
        flex-direction: column;
        align-items: flex-start;
        gap: 30px;
        padding: 32px 24px;
    }

    .cta-banner-image {
        width: 270px;
        max-width: 100%;
    }

    .listing-form-grid {
        grid-template-columns: 1fr;
    }

    .form-group-full,
    .form-submit-btn {
        grid-column: span 1;
    }


    .listing-hero-title {
        font-size: 32px;
        margin-bottom: 10px;
    }

    .listing-hero-desc {
        font-size: 14px;
        margin: 0 0 20px 0;
    }

    .listing-apply-btn {
        padding: 10px 24px;
        font-size: 13px;
    }

    .section-title {
        font-size: 28px;
    }
}

@media (max-width: 767px) {

    .listing-hero {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .listing-hero {
        padding: 0px;
    }

    .listing-hero-image {
        width: 240px;
    }

}

@media (max-width: 580px) {

    .listing-hero-title {
        font-size: 26px;
    }

    .listing-hero-desc {
        font-size: 13px;
        margin: 0 0 15px 0;
    }

    .section-title {
        font-size: 24px;
        margin: 0 0 15px 0;
    }

    .section-header {
        margin-bottom: 22px;
    }

    .process-grid {
        grid-template-columns: 1fr;
    }

    .process-card {
        padding: 22px;
    }

    .features-grid.grid-4,
    .features-grid.grid-3 {
        grid-template-columns: 1fr;
    }

    .listing-process-section {
        margin-bottom: 32px;
    }

    .feature-card {
        padding: 22px;
        align-items: center;
        text-align: center;
    }

    .listing-features-section {
        margin-bottom: 50px;
    }

    .cta-titlehome {
        font-size: 24px;
    }

    .cta-desc {
        font-size: 14px;
    }

    .listing-hero-image {
        right: 0px;
        position: relative;
    }

    .cta-banner-content {
        max-width: 100%;
    }

}

/* fix kero - Dark theme support for Listing Project page */
html[data-theme="dark"] .listing-project-page,
body:not(.light_theme) .listing-project-page {
    background-color: #181a20;
    color: #ffffff;
}

html[data-theme="dark"] .listing-hero-title,
html[data-theme="dark"] .section-title,
html[data-theme="dark"] .process-title,
html[data-theme="dark"] .feature-title,
html[data-theme="dark"] .cta-titlehome,
html[data-theme="dark"] .form-header h3,
body:not(.light_theme) .listing-hero-title,
body:not(.light_theme) .section-title,
body:not(.light_theme) .process-title,
body:not(.light_theme) .feature-title,
body:not(.light_theme) .cta-titlehome,
body:not(.light_theme) .form-header h3 {
    color: #ffffff;
}

html[data-theme="dark"] .listing-hero-desc,
html[data-theme="dark"] .listing-hero-subtitle,
html[data-theme="dark"] .section-subtitle,
html[data-theme="dark"] .process-desc,
html[data-theme="dark"] .feature-desc,
html[data-theme="dark"] .cta-desc,
html[data-theme="dark"] .form-header p,
body:not(.light_theme) .listing-hero-desc,
body:not(.light_theme) .listing-hero-subtitle,
body:not(.light_theme) .section-subtitle,
body:not(.light_theme) .process-desc,
body:not(.light_theme) .feature-desc,
body:not(.light_theme) .cta-desc,
body:not(.light_theme) .form-header p {
    color: #a0aab5;
}

html[data-theme="dark"] .process-card,
html[data-theme="dark"] .feature-card,
html[data-theme="dark"] .cta-banner-wrapper,
body:not(.light_theme) .process-card,
body:not(.light_theme) .feature-card,
body:not(.light_theme) .cta-banner-wrapper {
    background-color: #181a20;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    border: 1px solid #2b3139;
}

html[data-theme="dark"] .process-icon-wrapper,
body:not(.light_theme) .process-icon-wrapper {
    background-color: #21252f;
}

html[data-theme="dark"] .listing-modal-content,
body:not(.light_theme) .listing-modal-content {
    background-color: rgb(24 26 32 / 60%);
    color: #ffffff;
}

html[data-theme="dark"] .form-input,
body:not(.light_theme) .form-input {
    background-color: #ffffff0a;
    border-color: #2b3139;
    color: #ffffff;
}

html[data-theme="dark"] .form-input:focus,
body:not(.light_theme) .form-input:focus {
    background-color: #0d1219;
    border-color: #D3B06C;
}

html[data-theme="dark"] .modal-close-btn,
body:not(.light_theme) .modal-close-btn {
    background: #2b3139;
    color: #a0aab5;
}

html[data-theme="dark"] .modal-close-btn:hover,
body:not(.light_theme) .modal-close-btn:hover {
    background-color: #3b424a;
    color: #ffffff;
}

html[data-theme="dark"] .form-field label,
body:not(.light_theme) .form-field label {
    color: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ListCoin/listing-project.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,yCAAyC;AACzC;IACI,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,8DAA8D;AAC9D;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,0FAA0F;AAC9F;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,YAAY;IACZ,aAAa;IACb,6FAA6F;AACjG;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,4FAA4F;AAChG;;AAEA;IACI,aAAa;IACb,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,6FAA6F;AACjG;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA,4BAA4B;AAC5B;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,oDAAoD;IACpD,2DAA2D;AAC/D;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;;AAGA;;+EAE+E;AAC/E;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;;AAGA;;+EAE+E;AAC/E;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;;AAGA;;+EAE+E;AAC/E;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;+EAE+E;;AAE/E;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,wDAAwD;IACxD,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,WAAW;IACX,kCAA0B;YAA1B,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;;AAGA;;+EAE+E;;AAE/E;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;;IAGI;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;;QAEI,qCAAqC;IACzC;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;;;IAGI;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,mBAAmB;IACvB;;;IAGA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA,2DAA2D;AAC3D;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;;;;;;;;;IAYI,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;IAcI,cAAc;AAClB;;AAEA;;;;;;IAMI,yBAAyB;IACzB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;IAC3B,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB","sourcesContent":["/* ==========================================================================\n   AGCX Listing Project Page Styles\n   File: listing-project.css\n   ========================================================================== */\n\n/* --- Main Page Container & Layout --- */\n.listing-project-page {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 60px 0 100px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n/* Background Ambient Blur Blobs (Section-wise Left & Right) */\n.bg-blur-glow {\n    position: absolute;\n    border-radius: 50%;\n    pointer-events: none;\n    z-index: 0;\n    filter: blur(80px);\n    opacity: 0.85;\n}\n\n.glow-top-left {\n    top: -140px;\n    opacity: 0.3;\n    left: -200px;\n    width: 450px;\n    height: 450px;\n    background: radial-gradient(circle, rgb(209 170 103 / 90%) 0%, rgba(246, 224, 172, 0) 70%);\n}\n\nbody.light_theme .glow-middle-left {\n    opacity: 1;\n}\n\n.glow-middle-right {\n    opacity: 0.3;\n    top: 260px;\n    right: -120px;\n    width: 500px;\n    height: 500px;\n    background: radial-gradient(circle, rgba(191, 223, 255, 0.75) 0%, rgba(191, 223, 255, 0) 70%);\n}\n\nbody.light_theme .glow-middle-right {\n    opacity: 1;\n}\n\n.glow-middle-left {\n    top: 750px;\n    left: -140px;\n    opacity: 0.2;\n    width: 520px;\n    height: 520px;\n    background: radial-gradient(circle, rgba(191, 223, 255, 0.7) 0%, rgba(191, 223, 255, 0) 70%);\n}\n\n.glow-bottom-right {\n    bottom: -80px;\n    right: -120px;\n    width: 580px;\n    opacity: 0.2;\n    height: 580px;\n    background: radial-gradient(circle, rgba(246, 224, 172, 0.75) 0%, rgba(246, 224, 172, 0) 70%);\n}\n\nbody.light_theme .glow-bottom-right {\n    opacity: 1;\n}\n\n.listing-project-container {\n    max-width: 1440px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 1;\n}\n\n/* Common Gold Accent Text */\n.listing-hero .gold-text {\n    color: #D3B06C;\n    font-weight: 700;\n    display: block;\n}\n\n/* Common Primary CTA Button */\n.listing-apply-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 14px 28px;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-size: 16px;\n    font-weight: 500;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    text-decoration: none;\n}\n\n.listing-apply-btn:hover {\n    background-color: #C09D5B;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);\n}\n\n.listing-apply-btn i {\n    font-size: 16px;\n    transition: transform 0.2s ease;\n}\n\n.listing-apply-btn:hover i {\n    transform: translateX(3px);\n}\n\n\n/* ==========================================================================\n   --- Hero Section ---\n   ========================================================================== */\n.listing-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 60px;\n    margin-bottom: 90px;\n    padding-top: 20px;\n}\n\n.listing-hero-content {\n    flex: 1;\n    max-width: 580px;\n}\n\n.listing-hero-subtitle {\n    display: block;\n    font-size: 14px;\n    font-weight: 500;\n    color: #9CA3AF;\n    margin-bottom: 12px;\n    letter-spacing: 0.2px;\n}\n\n.listing-hero-title {\n    font-size: 52px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.25;\n    margin: 0 0 20px 0;\n}\n\n.listing-hero-desc {\n    font-size: 16px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 32px 0;\n}\n\n.listing-hero-image {\n    width: 400px;\n    max-width: 100%;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    bottom: 0px;\n    right: 60px;\n}\n\n.listing-hero-image img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n    filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.05));\n    animation: floatAnimation 4s ease-in-out infinite alternate;\n}\n\n@keyframes floatAnimation {\n    0% {\n        transform: translateY(0px);\n    }\n\n    100% {\n        transform: translateY(-10px);\n    }\n}\n\n\n/* ==========================================================================\n   --- AGCX Listing Process Section ---\n   ========================================================================== */\n.listing-process-section {\n    margin-bottom: 90px;\n}\n\n.section-header {\n    text-align: center;\n    margin-bottom: 44px;\n}\n\n.section-subtitle {\n    display: block;\n    font-size: 16px;\n    font-weight: 500;\n    color: #9CA3AF;\n    margin-bottom: 6px;\n}\n\n.section-title {\n    font-size: 32px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0;\n    letter-spacing: -0.3px;\n}\n\n.process-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n}\n\n.process-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 18px;\n    padding: 30px 20px 28px 20px;\n    text-align: center;\n    box-shadow: 0 0px 4px rgb(0 0 0 / 8%);\n    transition: all 0.25s ease;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.process-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.06);\n    border-color: #E2E8F0;\n}\n\n.step-badge {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background-color: #F8FAFC;\n    border: 1px solid #E2E8F0;\n    color: #D1AA67;\n    font-size: 13px;\n    font-weight: 800;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.process-icon {\n    height: 65px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.process-icon img {\n    max-height: 100%;\n    width: auto;\n    object-fit: contain;\n}\n\n.process-card h3 {\n    font-size: 17px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 10px 0;\n    line-height: 1.3;\n}\n\nbody.light_theme .process-card h3 {\n    color: #111827;\n}\n\n.process-card p {\n    font-size: 13px;\n    color: #64748B;\n    line-height: 1.55;\n    margin: 0;\n}\n\n\n/* ==========================================================================\n   --- Why List With Us / Features Section ---\n   ========================================================================== */\n.listing-features-section {\n    margin-bottom: 100px;\n}\n\n.features-grid {\n    display: grid;\n    gap: 24px;\n}\n\n.features-grid.grid-4 {\n    grid-template-columns: repeat(4, 1fr);\n    margin-bottom: 24px;\n}\n\n.features-grid.grid-3 {\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.feature-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 18px;\n    padding: 28px 24px;\n    box-shadow: 0 0px 4px rgb(0 0 0 / 8%);\n    transition: all 0.25s ease;\n    display: flex;\n    flex-direction: column;\n}\n\n.feature-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.06);\n    border-color: #E2E8F0;\n}\n\n.feature-icon {\n    height: 65px;\n    display: flex;\n    align-items: center;\n    margin-bottom: 18px;\n}\n\n.feature-icon img {\n    max-height: 100%;\n    width: auto;\n    object-fit: contain;\n}\n\n.feature-card h3 {\n    font-size: 17px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 8px 0;\n    line-height: 1.3;\n}\n\nbody.light_theme .feature-card h3 {\n    color: #111827;\n}\n\n.feature-card p {\n    font-size: 13.5px;\n    color: #64748B;\n    line-height: 1.55;\n    margin: 0;\n}\n\n\n/* ==========================================================================\n   --- Call to Action Banner Section ---\n   ========================================================================== */\n.listing-cta-banner {\n    background: #f7f7f70f;\n    border: none;\n    border-radius: 24px;\n    padding: 52px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    /* overflow: hidden; */\n    margin-bottom: 60px;\n}\n\nbody.light_theme .listing-cta-banner {\n    background: #F7F7F7;\n}\n\n.cta-banner-content {\n    max-width: 520px;\n    z-index: 2;\n}\n\n.cta-subtitle {\n    display: block;\n    font-size: 16px;\n    font-weight: 600;\n    color: #D3B06C;\n    margin-bottom: 8px;\n}\n\n.cta-titlehome {\n    font-size: 34px;\n    font-weight: 800;\n    color: #111827;\n    margin: 0 0 14px 0;\n    line-height: 1.2;\n    letter-spacing: -0.4px;\n}\n\n.cta-desc {\n    font-size: 15px;\n    color: #475569;\n    line-height: 1.6;\n    margin: 0 0 28px 0;\n}\n\n.cta-banner-image {\n    width: 450px;\n    max-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n\n.cta-banner-image img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n/* ==========================================================================\n   --- Listing Application Form (Modal Section) ---\n   ========================================================================== */\n\n.listing-form-header {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.listing-form-header h3 {\n    font-size: 24px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 8px 0;\n}\n\nbody.light_theme .listing-form-header h3 {\n    color: #111827;\n}\n\n.listing-form-header p {\n    font-size: 14px;\n    color: #64748B;\n    margin: 0;\n}\n\n.listing-form-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n}\n\n.form-group-full {\n    grid-column: span 2;\n}\n\n.form-field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.form-field label {\n    font-size: 13.5px;\n    font-weight: 600;\n    color: #334155;\n}\n\n.form-field label .required {\n    color: #EF4444;\n    margin-left: 3px;\n}\n\n.form-input {\n    width: 100%;\n    padding: 12px 16px;\n    border-radius: 10px;\n    border: 1px solid #CBD5E1;\n    background-color: #F8FAFC;\n    font-size: 14px;\n    color: #0F172A;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    outline: none;\n}\n\n.form-input:focus {\n    border-color: #D3B06C;\n    background-color: #FFFFFF;\n    box-shadow: 0 0 0 3px rgba(211, 176, 108, 0.15);\n}\n\n.form-phone-group {\n    display: flex;\n    gap: 10px;\n}\n\n.form-phone-code {\n    width: 100px;\n    flex-shrink: 0;\n}\n\n.form-submit-btn {\n    grid-column: span 2;\n    margin-top: 10px;\n    padding: 14px;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-size: 16px;\n    font-weight: 600;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.form-submit-btn:hover {\n    background-color: #C09D5B;\n}\n\n/* Modal Overlay */\n.listing-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(5px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999999999;\n    padding: 20px;\n    animation: fadeIn 0.2s ease;\n}\n\nbody.light_theme .listing-modal-overlay {\n    background-color: rgba(255, 255, 255, 0.20);\n}\n\n.listing-modal-content {\n    background-color: rgb(255 255 255 / 20%);\n    border-radius: 24px;\n    width: 100%;\n    backdrop-filter: blur(5px);\n    max-width: 680px;\n    max-height: 90vh;\n    overflow-y: auto;\n    padding: 36px;\n    position: relative;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.modal-close-btn {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background: #F1F5F9;\n    border: none;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #64748B;\n    font-size: 20px;\n    transition: all 0.2s ease;\n}\n\n.modal-close-btn:hover {\n    background-color: #E2E8F0;\n    color: #0F172A;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n\n/* ==========================================================================\n   --- Responsive Adjustments ---\n   ========================================================================== */\n\n@media (max-width: 1500px) {\n\n    .listing-project-container {\n        max-width: 95%;\n    }\n\n    .listing-hero-title {\n        font-size: 48px;\n    }\n\n}\n\n@media (max-width: 1200px) {\n\n    .cta-banner-image {\n        width: 320px;\n    }\n\n    .cta-titlehome {\n        font-size: 28px;\n    }\n\n    .listing-hero-title {\n        font-size: 38px;\n    }\n\n    .section-title {\n        font-size: 36px;\n    }\n\n}\n\n@media (max-width: 1024px) {\n\n\n    .listing-hero-title {\n        font-size: 38px;\n    }\n\n    .process-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .features-grid.grid-4,\n    .features-grid.grid-3 {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .listing-cta-banner {\n        padding: 40px;\n    }\n}\n\n@media (max-width: 991px) {\n\n\n    .listing-hero {\n        gap: 30px;\n        margin-bottom: 60px;\n    }\n\n    .listing-hero-image {\n        width: 280px;\n        right: 10px;\n    }\n\n    .process-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .features-grid.grid-4,\n    .features-grid.grid-3 {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .cta-banner-content {\n        max-width: 60%;\n    }\n\n    .listing-cta-banner {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 30px;\n        padding: 32px 24px;\n    }\n\n    .cta-banner-image {\n        width: 270px;\n        max-width: 100%;\n    }\n\n    .listing-form-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .form-group-full,\n    .form-submit-btn {\n        grid-column: span 1;\n    }\n\n\n    .listing-hero-title {\n        font-size: 32px;\n        margin-bottom: 10px;\n    }\n\n    .listing-hero-desc {\n        font-size: 14px;\n        margin: 0 0 20px 0;\n    }\n\n    .listing-apply-btn {\n        padding: 10px 24px;\n        font-size: 13px;\n    }\n\n    .section-title {\n        font-size: 28px;\n    }\n}\n\n@media (max-width: 767px) {\n\n    .listing-hero {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .listing-hero {\n        padding: 0px;\n    }\n\n    .listing-hero-image {\n        width: 240px;\n    }\n\n}\n\n@media (max-width: 580px) {\n\n    .listing-hero-title {\n        font-size: 26px;\n    }\n\n    .listing-hero-desc {\n        font-size: 13px;\n        margin: 0 0 15px 0;\n    }\n\n    .section-title {\n        font-size: 24px;\n        margin: 0 0 15px 0;\n    }\n\n    .section-header {\n        margin-bottom: 22px;\n    }\n\n    .process-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .process-card {\n        padding: 22px;\n    }\n\n    .features-grid.grid-4,\n    .features-grid.grid-3 {\n        grid-template-columns: 1fr;\n    }\n\n    .listing-process-section {\n        margin-bottom: 32px;\n    }\n\n    .feature-card {\n        padding: 22px;\n        align-items: center;\n        text-align: center;\n    }\n\n    .listing-features-section {\n        margin-bottom: 50px;\n    }\n\n    .cta-titlehome {\n        font-size: 24px;\n    }\n\n    .cta-desc {\n        font-size: 14px;\n    }\n\n    .listing-hero-image {\n        right: 0px;\n        position: relative;\n    }\n\n    .cta-banner-content {\n        max-width: 100%;\n    }\n\n}\n\n/* fix kero - Dark theme support for Listing Project page */\nhtml[data-theme=\"dark\"] .listing-project-page,\nbody:not(.light_theme) .listing-project-page {\n    background-color: #181a20;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .listing-hero-title,\nhtml[data-theme=\"dark\"] .section-title,\nhtml[data-theme=\"dark\"] .process-title,\nhtml[data-theme=\"dark\"] .feature-title,\nhtml[data-theme=\"dark\"] .cta-titlehome,\nhtml[data-theme=\"dark\"] .form-header h3,\nbody:not(.light_theme) .listing-hero-title,\nbody:not(.light_theme) .section-title,\nbody:not(.light_theme) .process-title,\nbody:not(.light_theme) .feature-title,\nbody:not(.light_theme) .cta-titlehome,\nbody:not(.light_theme) .form-header h3 {\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .listing-hero-desc,\nhtml[data-theme=\"dark\"] .listing-hero-subtitle,\nhtml[data-theme=\"dark\"] .section-subtitle,\nhtml[data-theme=\"dark\"] .process-desc,\nhtml[data-theme=\"dark\"] .feature-desc,\nhtml[data-theme=\"dark\"] .cta-desc,\nhtml[data-theme=\"dark\"] .form-header p,\nbody:not(.light_theme) .listing-hero-desc,\nbody:not(.light_theme) .listing-hero-subtitle,\nbody:not(.light_theme) .section-subtitle,\nbody:not(.light_theme) .process-desc,\nbody:not(.light_theme) .feature-desc,\nbody:not(.light_theme) .cta-desc,\nbody:not(.light_theme) .form-header p {\n    color: #a0aab5;\n}\n\nhtml[data-theme=\"dark\"] .process-card,\nhtml[data-theme=\"dark\"] .feature-card,\nhtml[data-theme=\"dark\"] .cta-banner-wrapper,\nbody:not(.light_theme) .process-card,\nbody:not(.light_theme) .feature-card,\nbody:not(.light_theme) .cta-banner-wrapper {\n    background-color: #181a20;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n    border: 1px solid #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .process-icon-wrapper,\nbody:not(.light_theme) .process-icon-wrapper {\n    background-color: #21252f;\n}\n\nhtml[data-theme=\"dark\"] .listing-modal-content,\nbody:not(.light_theme) .listing-modal-content {\n    background-color: rgb(24 26 32 / 60%);\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .form-input,\nbody:not(.light_theme) .form-input {\n    background-color: #ffffff0a;\n    border-color: #2b3139;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .form-input:focus,\nbody:not(.light_theme) .form-input:focus {\n    background-color: #0d1219;\n    border-color: #D3B06C;\n}\n\nhtml[data-theme=\"dark\"] .modal-close-btn,\nbody:not(.light_theme) .modal-close-btn {\n    background: #2b3139;\n    color: #a0aab5;\n}\n\nhtml[data-theme=\"dark\"] .modal-close-btn:hover,\nbody:not(.light_theme) .modal-close-btn:hover {\n    background-color: #3b424a;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .form-field label,\nbody:not(.light_theme) .form-field label {\n    color: #e2e8f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
